import { Button, ButtonProps } from "@ui/button";
import { Loader2 } from "lucide-react";
import React from "react";

interface Props extends ButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
  loaderClassName?: string;
  action?: React.MouseEventHandler<HTMLButtonElement>;
}

interface LoaderProps extends ButtonProps {
  loaderClassName?: string;
}

export const ShadcnButton = ({
  children,
  disabled,
  isLoading,
  className,
  loaderClassName,
  action,
  ...props
}: Props) => {
  return (
    <Button
      className={`dark:bg-dark-primary dark:hover:bg-dark-primary/80 bg-primary hover:bg-primary/80 ${className}`}
      disabled={disabled}
      onClick={action}
      {...props}
    >
      {isLoading && (
        <Loader size={props.size} loaderClassName={loaderClassName} />
      )}
      {children}
    </Button>
  );
};

const Loader = ({ size, loaderClassName }: LoaderProps) => {
  return (
    <Loader2
      className={`animate-spin ltr:mr-2 rtl:ml-2 ${
        size == "lg" && "h-7 w-7"
      } ${loaderClassName}`}
    />
  );
};
